import { Fragment } from 'react';

import { BreadcrumbItem } from './components/BreadcrumbItem';
import { BreadcrumbSeparator } from './components/BreadcrumbSeparator';
import { BreadcrumbConfig } from './types';

type BreadcrumbListProps = {
  breadcrumbs: Array<BreadcrumbConfig>;
};

export const Breadcrumbs = ({ breadcrumbs }: BreadcrumbListProps) => {
  return (
    <div className="flex items-center gap-2 truncate" role="navigation" aria-label="Breadcrumb">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return (
          <Fragment key={breadcrumb.key}>
            <BreadcrumbItem breadcrumb={breadcrumb} isActive={isLast} />
            {!isLast ? <BreadcrumbSeparator /> : null}
          </Fragment>
        );
      })}
    </div>
  );
};
